import React from 'react';

type Props = { children: React.ReactNode; title?: string };

type State = { error: Error | null };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          background: 'var(--bg-app)',
          color: 'var(--text-primary)',
          textAlign: 'center',
          gap: 16,
        }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 800 }}>
            {this.props.title ?? 'Что-то пошло не так'}
          </div>
          <p style={{ color: 'var(--text-muted)', fontSize: 14, maxWidth: 360 }}>
            Попробуйте обновить страницу. Если ошибка повторяется — напишите в поддержку.
          </p>
          <button
            type="button"
            onClick={() => window.location.assign('/')}
            style={{
              padding: '12px 24px',
              borderRadius: 12,
              border: 'none',
              background: 'var(--accent)',
              color: '#fff',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            На главную
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
